<template>
<div>
    <Breadcrumbs main="Admin" submain="Setting" title="Site Setting" />
    <!-- Container-fluid starts-->
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body">
                        <div>
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="form-group">
                                        <label>Logo</label>
                                        <div>
                                            <img v-if="show_image" style="height: 80px; border-radius: 6px;" :src="show_image">
                                            <input :class="show_image ? 'ml-2' : 'ml-0'" type="file" accept="image/*" @change="uploadImage">
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Phone Number</label>
                                        <input class="form-control" type="text" v-model="settings.phone" placeholder="Enter phone number" />
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Email</label>
                                        <input class="form-control" type="text" v-model="settings.email" placeholder="Enter email address" />
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Opening Hour</label>
                                        <input class="form-control" type="text" v-model="settings.opening_hours" placeholder="Enter office open time" />
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Address</label>
                                        <input class="form-control" type="text" v-model="settings.address" placeholder="Enter office adress" />
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Facebook Link</label>
                                        <input class="form-control" type="text" v-model="settings.link.facebook" placeholder="Enter facebook link" />
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>YouTube</label>
                                        <input class="form-control" type="text" v-model="settings.link.youtube" placeholder="Enter youtube link" />
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>X Link</label>
                                        <input class="form-control" type="text" v-model="settings.link.x" placeholder="Enter x link" />
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>LinkedIn Link</label>
                                        <input class="form-control" type="text" v-model="settings.link.linked_in" placeholder="Enter linkedin link" />
                                    </div>
                                </div>
                            </div>
                            <div class="mt-3">
                                <b-button @click="handleSubmit">Submit</b-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Container-fluid Ends-->
</div>
</template>

<script>
import {
    myHost
} from '../../../_helpers/host';
import {
    mapState
} from 'vuex';
import loader from '../loader/loader.vue';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';

export default {
    components: {
        loader
    },

    data() {
        return {
            host: myHost.host,
            settings: {
                logo: null,
                phone: '',
                email: '',
                address: '',
                opening_hours: '',
                link: {
                    facebook: '',
                    x: '',
                    linked_in: '',
                    youtube: ''
                }
            },
            show_image: null
        };
    },

    computed: {
        ...mapState({
            new_setting: state => state.setting.settings,
            loading: state => state.setting.settingLoading,
            error: state => state.setting.settingError
        })
    },

    watch: {
        new_setting(oldValue, newValue) {
            this.settings.phone = this.new_setting.phone
            this.settings.email = this.new_setting.email
            this.settings.opening_hours = this.new_setting.opening_hours
            this.settings.address = this.new_setting.address
            this.settings.link.facebook = this.new_setting.link.facebook
            this.settings.link.x = this.new_setting.link.x
            this.settings.link.youtube = this.new_setting.link.youtube
            this.settings.link.linked_in = this.new_setting.link.linked_in
            this.show_image = this.host + this.new_setting.logo
        }
    },

    mounted() {
        this.$store.dispatch("setting/fetchSetting")
    },

    methods: {
        uploadImage(e) {
            const image = e.target.files[0];
            const reader = new FileReader();
            reader.readAsDataURL(image);
            reader.onload = e => {
                this.settings.logo = e.target.result
                this.show_image = e.target.result
            };
        },

        resetModal() {
            this.settings= {
                logo: null,
                phone: null,
                address: null,
                email: null,
                opening_hours: null,
                link: {
                    facebook: '',
                    x: '',
                    linked_in: '',
                    youtube: ''
                }
            }
        },

        handleSubmit() {
            this.$store.dispatch("setting/addSetting", {
                setting: this.settings
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.resetModal();
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })

            this.$nextTick(() => {
                this.$bvModal.hide('modal-prevent-closing')
            })
        }
    }
};
</script>
